import { useLocalStorage } from "react-use";
import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";
import React from "react";
import { isSameDay, parseISO, startOfToday } from "date-fns";

interface Item {
  id: string;
  date: string;
}

export const SHAREPOINT_DAILY_SYNC_LIMIT = 20;

export const useSharepointSync = () => {
  const userData = useAuthenticatedUser();

  const key = `sharepointSyncing_${userData.id}`;

  const [synced, setRecentItems] = useLocalStorage<Item[]>(key, []);

  const addItem = React.useCallback(
    (item: string) => {
      setRecentItems(prevState => [
        ...(prevState || []),
        {
          id: item,
          date: new Date().toISOString(),
        },
      ]);
    },
    [setRecentItems],
  );

  const todaySync = (synced || []).filter(item => isSameDay(parseISO(item.date), startOfToday()));
  return { recentItems: synced || [], addRecentItem: addItem, canSync: todaySync.length < SHAREPOINT_DAILY_SYNC_LIMIT };
};
